let configInstance: any = null;

export const setConfigInstance = (config: any) => {
  configInstance = config;
};

export const getConfig = () => {
  if (!configInstance) {
    throw new Error('Config not initialized');
  }
  return configInstance;
};

export const updateApiPrefix = (companyName: string) => {
  if (configInstance) {
    const baseUrl = configInstance.newApiPrefix;

    configInstance.newApiPrefix = `${baseUrl}/${companyName}`;
  }
};

export const updateUrlsWithCompany = (companyName: string) => {
  if (configInstance && configInstance.companyLogin) {
    // Store original URLs if not already stored
    if (!configInstance._originalPosUrl) {
      configInstance._originalPosUrl = configInstance.posUrl;
    }
    if (!configInstance._originalOrderManagementUrl) {
      configInstance._originalOrderManagementUrl = configInstance.orderManagementUrl;
    }

    // Update URLs with company name
    configInstance.posUrl = `${configInstance._originalPosUrl}/${companyName}`;
    configInstance.orderManagementUrl = `${configInstance._originalOrderManagementUrl}/${companyName}`;
  }
};

export const resetUrlsToOriginal = () => {
  if (configInstance) {
    if (configInstance._originalPosUrl) {
      configInstance.posUrl = configInstance._originalPosUrl;
    }
    if (configInstance._originalOrderManagementUrl) {
      configInstance.orderManagementUrl = configInstance._originalOrderManagementUrl;
    }
  }
};
